<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <span class="title_head">Search Sales Return</span>
          </div>
          <div class="card-body">
            <b-row>
              <b-col sm="3" v-if="is_admin === true">
                <b-form-group>
                  <label for="Company List"> Company List </label><br />
                  <model-list-select
                    :list="companylist"
                    option-value="company_id"
                    option-text="company_name"
                    v-model="selectcompany"
                    placeholder="Search Company Name"
                    @searchchange="searchcompany($event)"
                    @input="onSelectCompnay($event)"
                    style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:30px !important; border: 1px solid rgb(194, 207, 214);min-height: 30px; border-radius: 1px; padding-top: 6px;"
                    class="product-drop"
                  ></model-list-select>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group>
                  <label for="name"> To Date </label><br />
                  <date-picker
                    editable
                    lang="en"
                    v-model="todate"
                  ></date-picker>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group>
                  <label for="name"> From Date </label><br />
                  <date-picker
                    editable
                    lang="en"
                    v-model="fromdate"
                  ></date-picker>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group>
                  <label for="name">Sale Return Id </label>
                  <b-form-input
                    type="text"
                    v-model="productunit"
                    placeholder="Enter Sale Return Id"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group>
                  <button
                    type="button"
                    v-if="salert_view === true"
                    style="margin-top: 24px; margin-left: 16%"
                    class="btn btn-pill btn-primary serach_bttn"
                    @click="searchsalesitem"
                  >
                    <i class="fa fa-search"></i>&nbsp;Search
                  </button>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <span class="title_head"
              >List Sale Return
              <span
                >&nbsp;&nbsp;
                <a href="#/sales/Salesreturn" v-if="salert_rights === true"
                  ><button
                    type="button"
                    class="btn btn-sm btn-primary label_bttn"
                  >
                    <i class="fa fa-plus"></i> Add Sales Return
                  </button></a
                >
              </span>
            </span>
          </div>
          <div class="card-body">
            <vue-good-table
               class="centered-table"
              :columns="columns"
              :rows="rows"
              mode="remote"
              ref="my-table"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
              :totalRows="totalRecords"
              :pagination-options="{
                enabled: true,
                perPage: 5
              }"
              styleClass="vgt-table striped bordered table-sm condensed"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action'">
                  <i
                    class="fa fa-eye"
                    @click="returnitem(props.row)"
                    style="color:#63c2de;font-size: 20px; cursor: pointer;"
                  ></i>
                  <span v-if="salert_rights === true">
                    <i
                      class="fa fa-trash-o"
                      style="color: #F44336;font-size: 20px; cursor: pointer;"
                      v-on:click="removeSalesReturn(props.row)"
                      title="Remove Sales Return"
                    ></i>
                    <!--<i class="fa fa-pencil" style="color:#63c2de;font-size: 20px; cursor: pointer;" v-on:click="editSalesReturn(props.row);" title="Edit Sale Return"></i>-->

                    <router-link
                      :to="{
                        name: 'Edit Sales Return',
                        params: {
                          saleReturnId: props.row.sales_return_id,
                          shopId: props.row.est_shop_id,
                          saleId: props.row.sales_id
                        }
                      }"
                      ><i
                        class="fa fa-pencil"
                        style="color:#63c2de;font-size: 20px; cursor: pointer;"
                        title="Edit Sale Return"
                      ></i
                    ></router-link>
                  </span>
                  <span v-else>
                    <i
                      class="fa fa-trash-o"
                      style="color:grey !important;font-size: 20px;"
                    ></i>
                    <i
                      class="fa fa-pencil"
                      style="color:grey !important;font-size: 20px;"
                    ></i>
                  </span>
                  <!-- <i class="fa fa-pencil" v-if="pg_rights" style="color:#63c2de;font-size: 20px; cursor: pointer;" v-b-tooltip.hover title="Edit Sale" v-on:click="editSalesReturn(props.row);"></i> -->
                </span>
                <span v-else-if="props.column.field == 'gst_total'">
                  {{
                    (
                      parseFloat(props.row.cgst_amt) +
                      parseFloat(props.row.sgst_amt) +
                      parseFloat(props.row.igst_amt)
                    ).toFixed(2)
                  }}
                </span>
                <span v-else-if="props.column.field == 'lastupdated_datetime'">
                  {{ newDate(props.row.lastupdated_datetime) }}
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      title="Sales Item Return Details "
      size="lg"
      hide-footer
      class="modal-warning"
      v-model="warningModal"
      @ok="warningModal = true"
      ok-variant="warning"
    >
      <b-collapse id="collapse1" visible>
        <vue-good-table
         class="centered-table"
          :columns="columns1"
          :rows="rows1"
          mode="remote"
          ref="my-table1"
          @on-page-change="onPageChange1"
          @on-sort-change="onSortChange1"
          @on-column-filter="onColumnFilter1"
          @on-per-page-change="onPerPageChange1"
          :totalRows="totalRecords1"
          :pagination-options="{
            enabled: true,
            perPage: 5
          }"
          styleClass="vgt-table striped bordered table-sm condensed"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'tax_inclusive'">
              <div v-if="props.row.tax_inclusive == true">Inclusive</div>
              <div v-else>Exclusive</div>
            </span>
            <span v-else-if="props.column.field == 'gst_total'">
              {{
                (
                  parseFloat(props.row.cgst_amt) +
                  parseFloat(props.row.sgst_amt) +
                  parseFloat(props.row.igst_amt)
                ).toFixed(2)
              }}
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </b-collapse>
    </b-modal>
  </div>
</template>

<script>
import Spinner from "../../spinner.vue";
import { VueEditor } from "vue2-editor";
import DatePicker from "vue2-datepicker";
export default {
  components: {
    "date-picker": DatePicker,
    Spinner
  },
  data() {
    return {
      companylist: [],
      selectcompany: null,
      slfirst: false,
      shpfirst: false,
      todate: null,
      fromdate: null,
      productunit: "",
      productqty: "",
      rows1: [],
      rows: [],
      warningModal: false,
      largeModal: false,
      loading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      // pg_view : false,
      // pg_rights : false,
      totalRecords1: 0,
      serverParams1: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      temprow: null,
      columns1: [
        {
          label: "Product Name",
          field: "product_name",
          width: "25% !important"
        },
       // {
          //label: "Variant",
         // field: "variant_id",
         // width: "15% !important"
       // },
          {
          label: "carat value",
          field: "carat_value",
          width: "10% !important",
        },
        {
          label: "Return Qty",
          field: "return_qty",
          width: "10% !important"
        },
        {
          label: "Price",
          field: "product_unit_cost",
          width: "10% !important",
          formatFn: this.formatFn
        },
        {
          label: "Sub Total",
          field: "sub_total",
          width: "10% !important",
          formatFn: this.formatFn
        },
        {
          label: "Tax",
          field: "tax_inclusive",
          width: "10% !important"
        },
        {
          label: "GST%",
          field: "gst_total",
          width: "15% !important"
        },
        {
          label: "Amount",
          field: "amt_to_pay",
          width: "15% !important",
          formatFn: this.formatFn
        }
      ],

      columns: [
        {
          label: "Sales Return Id",
          field: "sales_return_id",
          width: "5% !important"
        },
        {
          label: "Sales Id",
          field: "sales_id",
          width: "5% !important"
        },
        {
          label: "Customer",
          field: "cust_cmp_name",
          width: "18% !important"
        },
        {
          label: "Shop",
          field: "est_shop_name",
          width: "17% !important"
        },
        {
          label: "GST Amount",
          field: "gst_total",
          width: "10% !important"
        },
        {
          label: "Total Amount",
          field: "total_amt_pay",
          width: "15% !important",
          formatFn: this.formatFn
        },
        {
          label: "Date",
          field: "lastupdated_datetime",
          type: "date",
          dateInputFormat: "YYYY-MM-DDThh:mm:ss",
          dateOutputFormat: "DD/MM/YYYY",
          width: "15% !important",
          tdClass: "text-left",
          thClass: "text-left"
        },
        {
          label: "Action",
          field: "action",
          width: "15% !important"
        }
      ]
    };
  },
  computed: {
    salert_view: function() {
      if (this.$store.getters.get_is_admin !== true) {
        if (this.$store.getters.get_salert_view === true) {
          this.salesreturn("comp");
          this.shopuser("comp");
          return true;
        } else {
          return false;
        }
      }
    },
    salert_rights: function() {
      return this.$store.getters.get_salert_rights;
    },
    is_admin: function() {
      return this.$store.getters.get_is_admin;
    }
  },
  // created(){
  //   this.salesreturn();
  //   this.shopuser();

  //    var roles = JSON.parse(localStorage.getItem('roles'))
  //     // var roles = this.$store.state.userStore.roles

  //     if(roles[6].page_name == 7){
  //       this.pg_view = roles[6].view
  //       this.pg_rights = roles[6].rights
  //     }

  // },
  methods: {
    removeSalesReturn(row) {
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        var _this = this;
        this.loading = true;
        this.$http
          .delete(
            "api/salertdetails/removeSalesReturn?id=" +
              row.sales_return_id +
              "&shp_id=" +
              row.est_shop_id
          )
          .then(function(response) {
            if (response.status == 200) {
              _this.salesreturn();
              _this.loading = false;
            }
          })
          .catch(function(error) {
            _this.loading = false;
          });
      }
    },
    newDate(date1) {
      var dt1 = new Date(date1);
      var year = dt1.getFullYear();
      var month = dt1.getMonth() + 1;
      var day = dt1.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      if (month < 10) {
        month = "0" + month;
      }
      // var dt2 = year+'-'+month+'-'+day
      var dt2 = day + "-" + month + "-" + year;

      return dt2;
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        },
        page: 1
      });
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    updateParams1(newProps, row) {
      this.serverParams1 = Object.assign({}, this.serverParams1, newProps);
    },

    onPageChange1(params, row) {
      this.updateParams1({ page: params.currentPage });
      this.returnitem(this.temprow);
    },

    onPerPageChange1(params, row) {
      this.updateParams1({ perPage: params.currentPerPage, page: 1 });
      this.returnitem(this.temprow);
    },

    onSortChange1(params, row) {
      this.updateParams1({
        sort: {
          type: params.sortType,
          field: this.columns1[params.columnIndex].field
        },
        page: 1
      });
      this.returnitem(this.temprow);
    },

    onColumnFilter1(params, row) {
      this.updateParams1(params);
      this.returnitem(this.temprow);
    },

    searchcompany(searchText) {
      var _this = this;
      this.$http
        .get(
          "/api/companies?filter[where][company_name][ilike]=%" +
            searchText +
            "%"
        )
        .then(function(response) {
          // console.log(response)
          _this.companylist = response.data;
        })
        .catch(function(error) {});
    },

    onSelectCompnay(selected_company) {
      this.loadItems();
    },
    // load items is what brings back the rows from server
    loadItems() {
      var _this = this;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      this.loading = true;
      var _this = this;
      var data = [];
      this.rows = [];
      var unit = this.productunit;
      var qty = this.productqty;
      var num = /^[0-9]{1}$/;
      var dateto = new Date(this.todate);
      var year = dateto.getFullYear();
      var month = dateto.getMonth() + 1;
      var day = dateto.getDate();

      if (num.test(month) == true) {
        var month = "0" + month;
      } else {
        var month = month;
      }

      if (num.test(day) == true) {
        var day = "0" + day;
      } else {
        var day = day;
      }

      var datefrom = new Date(this.fromdate);
      var year1 = datefrom.getFullYear();
      var month1 = datefrom.getMonth() + 1;
      var daycon = datefrom.getDate();
      if (num.test(month1) == true) {
        var month1 = "0" + month1;
      } else {
        var month1 = month1;
      }

      if (num.test(daycon) == true) {
        var day1 = "0" + daycon;
      } else {
        var day1 = daycon;
      }

      var todate1 = year + "-" + month + "-" + day;
      var fromdate1 = year1 + "-" + month1 + "-" + day1;

      if (this.todate != null && this.fromdate != null) {
        data =
          data +
          " &filter[where][lastupdated_datetime][between][0]=" +
          todate1 +
          "&filter[where][lastupdated_datetime][between][1]=" +
          fromdate1;
      } else {
        if (this.todate != null) {
          data = data + "&filter[where][lastupdated_datetime]=" + todate1;
        }
        if (this.fromdate != null) {
          data = data + "&filter[where][lastupdated_datetime]=" + fromdate1;
        }
      }

      if (this.productunit != "") {
        data = data + "&filter[where][sales_return_id]=" + unit;
      }
      if (this.selectcompany !== null) {
        data =
          data +
          "&filter[where][company_id]=" +
          this.selectcompany.company_id +
          "&filter[where][user_id]=" +
          this.selectcompany.cmp_email + "&filter[where][regcity]=" +
          this.selectcompany.regcity_code;
      }
      this.$http
        .get(
          "/api/salesreturns/getSalesRtns?params=" +
            JSON.stringify(filteParam) +
            data
        )
        .then(function(response) {
          _this.totalRecords = response.data[0].totalRecords;
          response.data.shift();
          if (response.data != undefined) _this.rows = response.data;
          _this.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          _this.loading = false;
        });
    },
    shopuser(val) {
      if (val === "comp") {
        if (this.shpfirst === false) {
          this.shpfirst = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http
        .get("/api/shopusers")
        .then(function(response) {})
        .catch(function(error) {
          if (error.response.status === 401) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
          if (
            error.response.data.error.message ===
            "Cannot read property 'cmpname' of null"
          ) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
        });
    },

    formatFn(value) {
      return parseFloat(value).toFixed(2);
    },

    salesreturn(val) {
      if (val === "comp") {
        if (this.slfirst === false) {
          this.slfirst = true;
        } else {
          return;
        }
      }
      this.loadItems();
    },

    returnitem(row) {
      let filteParam = {};
      filteParam.page = this.serverParams1.page;
      filteParam.perPage = this.serverParams1.perPage;
      filteParam.sort = this.serverParams1.sort;
      this.warningModal = true;
      var _this = this;
      this.temprow = row;
      var data = [];
      var data =
        data + " &filter[where][sales_return_id]=" + row.sales_return_id;
      if(this.selectcompany !== null){
        data = data + "&filter[where][company_id]=" + this.selectcompany.company_id + "&filter[where][regcity]=" +
          this.selectcompany.regcity_code;
      }
      this.$http
        .get(
          "/api/salesreturns/searchdb?params=" +
            JSON.stringify(filteParam) +
            data
        )
        .then(function(response) {
          _this.totalRecords1 = response.data[0].totalRecords;
          response.data.shift();
          if (response.data != undefined) _this.rows1 = response.data;
        });
    },
    searchsalesitem() {
      this.updateParams({
        sort: {
          type: "",
          field: ""
        },
        page: 1
      });
      this.$refs["my-table"].reset();
      this.loadItems();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/sales/list.vue